module.exports = __webpack_public_path__ + "static/media/heart-fill.54db33fe.svg";